var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1730",
    "data-name": "Rectangle 1730",
    width: 17.452,
    height: 24.212,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Stage_6:_Customer_Delight",
    "data-name": "Stage 6: Customer Delight",
    transform: "translate(-592.108 -302.662)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_685",
    "data-name": "Ellipse 685",
    cx: 14,
    cy: 14,
    r: 14,
    transform: "translate(592.108 302.662)",
    fill: "#ee3d4b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_32061",
    "data-name": "Group 32061",
    transform: "translate(597.478 304.056)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32060",
    "data-name": "Group 32060",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13525",
    "data-name": "Path 13525",
    d: "M5.682,5.547a.356.356,0,0,0,.469-.534L2.275,2.394a.357.357,0,0,0-.5.034v0a.357.357,0,0,0,.034.5Z",
    transform: "translate(-0.069 -0.094)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13526",
    "data-name": "Path 13526",
    d: "M7.156,4.086a.355.355,0,1,0,.662-.259L6.075.488a.355.355,0,0,0-.662.259Z",
    transform: "translate(-0.219 -0.011)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13527",
    "data-name": "Path 13527",
    d: "M.13,15.376a3.477,3.477,0,0,0-.13.932A3.312,3.312,0,0,0,.658,18.3a2.771,2.771,0,0,0,1.6,1.044l.511.183-1.024,4.8.748.15,1.023-4.8.442.045a2.49,2.49,0,0,0,.553.062A2.6,2.6,0,0,0,5.8,19.439a3.1,3.1,0,0,0,1.51-2.472l.457-9.558-4.55-.913Zm2.621,1.742a.741.741,0,1,1-.74-.742.741.741,0,0,1,.74.742Zm.763-1.9a.741.741,0,1,1-.742.74.741.741,0,0,1,.742-.74Zm-.119-1.055a.741.741,0,1,1-.74-.742.74.74,0,0,1,.74.742Z",
    transform: "translate(0 -0.264)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13528",
    "data-name": "Path 13528",
    d: "M16.078,16.389a2.771,2.771,0,0,0,1.373-1.315,3.3,3.3,0,0,0,.288-2.081,3.354,3.354,0,0,0-.3-.891L12.771,3.938,8.47,5.67l2.2,9.306a3.1,3.1,0,0,0,1.94,2.154,2.615,2.615,0,0,0,1.334.1,2.565,2.565,0,0,0,.532-.161l.426-.126,1.884,4.528.707-.288-1.88-4.525ZM14.61,10.644a.741.741,0,1,1-.593.864h0a.741.741,0,0,1,.593-.863m-.253,3.377a.741.741,0,1,1,.593-.864.741.741,0,0,1-.593.864m.826.269a.741.741,0,0,1,1.456-.271h0a.74.74,0,0,1-.592.862h0a.741.741,0,0,1-.863-.593",
    transform: "translate(-0.344 -0.16)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13529",
    "data-name": "Path 13529",
    d: "M9.448,3.84a.4.4,0,0,0,.106.016.355.355,0,0,0,.34-.252l.65-3.143v0a.356.356,0,0,0-.236-.443l-.007,0a.35.35,0,0,0-.437.237L9.214,3.4h0a.357.357,0,0,0,.235.445",
    transform: "translate(-0.373 0)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelight);
export default __webpack_public_path__ + "static/media/delight.10ea4c24aca3f571a1b4534cd0112907.svg";
export { ForwardRef as ReactComponent };